import { useEffect, useRef } from 'react';
import { useBillboardCollection } from 'app/agriculture/FarmMain/MapRenderer/context/BillboardCollectionContext';

interface Props {
    billboardOptions: Partial<Cesium.Billboard>;
}

export function CesiumBillboard({ billboardOptions }: Props) {
    const collection = useBillboardCollection();
    const optionsRef = useRef<Partial<Cesium.Billboard>>(billboardOptions);
    const billboardRef = useRef<Cesium.Billboard | undefined>(undefined);

    // initialise the billboard
    useEffect(() => {
        billboardRef.current = collection.add(optionsRef.current);

        return () => {
            if (collection.isDestroyed() || billboardRef.current == null) return;
            collection.remove(billboardRef.current);
        };
    }, [collection]);

    // update the billboard when options change
    useEffect(() => {
        if (!billboardRef.current) return;
        Object.assign(billboardRef.current, billboardOptions);
    }, [billboardOptions]);

    return null;
}
